export const NeonIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1486_10520)">
        <path
          d="M6.54694 10.59L6.90049 10.9426L7.25355 10.5896L12.1707 5.67236L12.5941 6.09875L6.9 11.7929L3.60711 8.5L4.02849 8.07861L6.54694 10.59ZM1 8.5C1 4.36014 4.36014 1 8.5 1C12.6399 1 16 4.36014 16 8.5C16 12.6399 12.6399 16 8.5 16C4.36014 16 1 12.6399 1 8.5ZM1.6 8.5C1.6 12.3121 4.68786 15.4 8.5 15.4C12.3121 15.4 15.4 12.3121 15.4 8.5C15.4 4.68786 12.3121 1.6 8.5 1.6C4.68786 1.6 1.6 4.68786 1.6 8.5Z"
          fill="#0BEC9F"
          stroke="#0BEC9F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1486_10520">
          <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
